import { useMemo } from 'react'
import { useTranslations } from './useTranslations'
import { capitalize } from '@based/ui'

export const useNavigation = () => {
  const { data: dictionary = {}, checksum: dictionaryChecksum } =
    useTranslations('navigation')

  const navigation = useMemo(
    () => [
      {
        label: capitalize(dictionary?.home_title ?? ''),
        route: '/',
      },
      {
        label: capitalize(dictionary?.cart_title ?? ''),
        route: '/cart',
      },
      {
        label: capitalize(dictionary?.terms_and_conditions_title ?? ''),
        route: '/terms-and-conditions',
      },
      {
        label: capitalize(dictionary?.privacy_policy_title ?? ''),
        route: '/privacy-policy',
      },
    ],
    [dictionaryChecksum],
  )

  return navigation
}
